import { graphql } from "~/gql";

export const UPDATE_LIBRARY_DISBURSEMENTS = graphql(/* GraphQL */ `
  mutation UpdateLibraryDisbursements($data: [LibraryDisbursementUpdate!]!) {
    updateLibraryDisbursements(data: $data) {
      id
      name
      amount
      vatStatus
    }
  }
`);
